/**
 * Branding Configuration (White-Label)
 * Centralized branding values read from environment variables.
 * Every consumer reads from here — never hardcode brand strings elsewhere.
 */

export interface BrandingColors {
  /** Primary color — buttons, links, active states (e.g. "#a11858") */
  primaryMain: string;
  primaryLight: string;
  primaryDark: string;
  /** Secondary color — accents, secondary buttons (e.g. "#0d9488") */
  secondaryMain: string;
  secondaryLight: string;
  secondaryDark: string;
  /** Accent/brand color — info badges, highlights (e.g. "#7c3aed") */
  accentMain: string;
  accentLight: string;
  accentDark: string;
  /** Header/AppBar background color (e.g. "#1E293B") */
  headerBg: string;
  /** Login gradient start color */
  loginGradientStart: string;
  /** Login gradient end color */
  loginGradientEnd: string;
}

export interface BrandingConfig {
  /** Application name (e.g. "MEV-Med") */
  appName: string;
  /** Short description / tagline */
  appDescription: string;
  /** Copyright holder text (e.g. "MEV-Med") */
  appCopyright: string;
  /** Path to the light/white logo (used on dark backgrounds) */
  logoLight: string;
  /** Path to the color/dark logo (used on light backgrounds) */
  logoDark: string;
  /** Path to the small logo / icon */
  logoSmall: string;
  /** Path to the favicon */
  favicon: string;
  /** Theme colors */
  colors: BrandingColors;
}

const branding: BrandingConfig = {
  appName: import.meta.env.VITE_APP_NAME || 'MEVMED',
  appDescription: import.meta.env.VITE_APP_DESCRIPTION || 'Medicina Ocupacional',
  appCopyright: import.meta.env.VITE_APP_COPYRIGHT || 'MEVMED',
  logoLight: import.meta.env.VITE_LOGO_LIGHT || '/images/logoMevMedBig-(Branco).png',
  logoDark: import.meta.env.VITE_LOGO_DARK || '/images/logoMevMedBig.png',
  logoSmall: import.meta.env.VITE_LOGO_SMALL || '/images/logoMevMedSmall.png',
  favicon: import.meta.env.VITE_FAVICON || '/favicon.png',
  colors: {
    primaryMain: import.meta.env.VITE_THEME_PRIMARY || '#a11858',
    primaryLight: import.meta.env.VITE_THEME_PRIMARY_LIGHT || '#c24e7e',
    primaryDark: import.meta.env.VITE_THEME_PRIMARY_DARK || '#7a1042',
    secondaryMain: import.meta.env.VITE_THEME_SECONDARY || '#0d9488',
    secondaryLight: import.meta.env.VITE_THEME_SECONDARY_LIGHT || '#2dd4bf',
    secondaryDark: import.meta.env.VITE_THEME_SECONDARY_DARK || '#0f766e',
    accentMain: import.meta.env.VITE_THEME_ACCENT || '#7c3aed',
    accentLight: import.meta.env.VITE_THEME_ACCENT_LIGHT || '#a78bfa',
    accentDark: import.meta.env.VITE_THEME_ACCENT_DARK || '#5b21b6',
    headerBg: import.meta.env.VITE_THEME_HEADER_BG || '#1E293B',
    loginGradientStart: import.meta.env.VITE_THEME_LOGIN_GRADIENT_START || '#7a1042',
    loginGradientEnd: import.meta.env.VITE_THEME_LOGIN_GRADIENT_END || '#1E293B',
  },
};

export default branding;
